import http from './http';

// Channels (for current authenticated user)
// GET effective channels for a website
const getMyChannels = (websiteId) => {
  if (!websiteId) throw new Error('websiteId is required');
  return http.get(`/me/channels/website/${websiteId}`);
};

// PUT updates to channels for a website
// payload shape: { channels: { key: { email?: boolean, push?: boolean }, ... } }
const updateMyChannels = (websiteId, payload) => {
  if (!websiteId) throw new Error('websiteId is required');
  return http.put(`/me/channels/website/${websiteId}`, payload || {});
};

export default { getMyChannels, updateMyChannels };
export { getMyChannels, updateMyChannels };
